<template>
  <div>
    <div class="mt-3">
      <div
        class="chips-container"
        :class="{
          'no-background': noBackground,
        }"
      >
        <p class="bold mb-2">
          {{ title }}
        </p>
        <div
          v-for="item in selectedItems"
          :key="item[objectId]"
          class="label label-default chips highlight"
          :class="{
            'labe-no-wrapp': noWrap,
          }"
        >
          <div class="inline chips-title">
            <b v-if="itemHasTitle(item)">{{ item[objectTitle] }}</b>
            <i v-if="item[objectSubTitle]">- {{ item[objectSubTitle] }}</i>
            <i v-if="itemHasTitle(item)">{{ item[objectText] }}</i>
            <span v-if="!itemHasTitle(item)">{{ item[objectText] }}</span>
          </div>

          <i
            v-if="!item.disabled && !disabled"
            class=" mt-1 ml-2  far fa-times-circle pointer deleted-button"
            @click.prevent.stop="onItemDeleted(item)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.labe-no-wrapp {
  white-space: initial !important;
  overflow-wrap: anywhere;
}

.label {
  display: inline-table;
  padding: 0.2em 0.6em 0.3em;
  margin-left: 0.5rem;
  margin-top: 0.5em;
  white-space: nowrap;
  vertical-align: baseline;
  border: 1px solid #b5c3bc;
  border-radius: 13px;
  color: #11291b;
  opacity: 1;
}
.label-default {
  background-color: #ffffff;
}
.chips {
  border-radius: 30px !important;
  font-size: 16px;
  letter-spacing: 0;
  width: auto;
}
.chips.with-title {
  padding-left: 15px;
  padding-right: 8px;
}

.deleted-button {
  font-size: 18px;
  margin-left: 18px;
  color: #c74545;
  border-color: #ffffff;
  padding-top: 3px;
}

.chips-container {
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
  margin-top: 0.7%;
  padding-top: 1%;
  padding-bottom: 1.5em;
}
.chips-container.no-background {
  background-color: transparent;
  box-shadow: none;
}
.chips-container p {
  font-size: 1rem;
  font-weight: 400;
  color: #727272;
}
.chips-container p.bold {
  font-weight: 700;
}
.chips-container div {
  font-size: 1rem;
  font-weight: 400;
  color: #727272;
}
.chips-container div.chips-title {
  margin-bottom: 0;
  font-weight: bold;
  color: #11291b;
  line-height: 0.8;
  padding-top: 10px;
}
.pointer {
  cursor: pointer;
}
.inline {
  display: inline;
}
.inline b {
  color: #11291b;
}
.inline.with-title {
  font-size: 14px !important;
}
@-webkit-keyframes red-fade {
  0% {
    background: #20a874;
  }
  100% {
    background: none;
  }
}
@keyframes red-fade {
  0% {
    background: #20a874;
  }
  100% {
    background: none;
  }
}
.highlight {
  -webkit-animation: red-fade 1s ease-in 1;
  animation: red-fade 1s ease-in 1;
}
</style>

<script>
export default {
  name: 'CustomChipsGroup',
  meta: {
    description: 'Componente personalizado de selecciones',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    selectedItems: {
      type: Array,
      default: function() {
        return [];
      },
      meta: {
        description: 'Estado seleccionado',
        example: '[4, 8, 15, 16, 23, 42]',
      },
    },
    title: {
      type: String,
      default: 'Selección de Evaluaciones',
      meta: {
        description: 'Estable el encabezado',
        example: 'Texto requerido',
      },
    },
    objectId: {
      type: String,
      required: false,
      default: 'id',
      meta: {
        description: 'Establece el id del objeto',
        example: 'Texto requerido',
      },
    },
    objectText: {
      type: String,
      required: false,
      default: 'text',
      meta: {
        description: 'Control para mostrar texto',
        example: 'Texto requerido',
      },
    },
    objectTitle: {
      type: String,
      required: false,
      default: '',
      meta: {
        description: 'Control para mostrar títulos',
        example: 'Texto requerido',
      },
    },
    objectSubTitle: {
      type: String,
      required: false,
      default: '',
      meta: {
        description: 'Control para mostrar subtítulos',
        example: 'Texto requerido',
      },
    },
    noBackground: {
      type: Boolean,
      default: false,
      required: false,
      meta: {
        description: 'No permitirle fondo al componente',
        example: 'true',
      },
    },
    disabled: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Establece opciones deshabilitadas',
        example: 'true',
      },
    },
    noWrap: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    hasTitle() {
      return this.objectTitle != '';
    },
  },
  methods: {
    itemHasTitle(item) {
      return item[this.objectTitle] != null;
    },
    onItemDeleted(item) {
      this.$emit('itemMarkedForDeletion', { ...item });
    },
    isLastItem(item) {
      return item.id == this.LastItem;
    },
  },
};
</script>
